import { render, staticRenderFns } from "./sectionUserNotifications.vue?vue&type=template&id=0ddde790"
import script from "./sectionUserNotifications.vue?vue&type=script&lang=js"
export * from "./sectionUserNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports